import classNames from "classnames";
import { useFormContext } from "react-hook-form";

// Components
import InputSearch from "components/atoms/InputSearch";

// Constants
import { SearchFields } from "constants/variables";

// Hooks
import useTranslate from "hooks/useTranslate";

// Icons
import DoneIcon from "assets/icons/banger/done.svg?react";

import "./styles.sass";

type CurrencyListMobileProps = {
  list: string[];
  selected: string;
  onSelect: (item: string) => void;
};

const CurrencyListMobile = (props: CurrencyListMobileProps) => {
  const { list, selected, onSelect } = props;

  const { watch } = useFormContext();

  const t = useTranslate();

  const searchValue = watch(SearchFields.CURRENCY);

  return (
    <div className="CurrencyListMobile">
      <InputSearch
        mode={
          import.meta.env.VITE_APP_PROJECT_NAME === "banger" ? "dark" : "light"
        }
        placeholder={t("placeholder.search")}
        name={SearchFields.CURRENCY}
        value=""
      />
      <div className="CurrencyListMobile__list">
        {list
          .filter((item) => {
            if (item && searchValue) {
              return (
                item.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1
              );
            }
            return true;
          })
          .map((item: string, index: number) => {
            const itemClass = classNames("CurrencyListMobile__item", {
              active: item === selected,
            });
            return (
              <div
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                className={itemClass}
                onClick={() => onSelect(item)}
              >
                {item} {item === selected && <DoneIcon />}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default CurrencyListMobile;
